import { GhostIcon } from './GhostIcon';

/**
 * author: Simran
 * id 6B39D7DA-255C-4615-84D4-FFCF34D76A4A
 * name ghost
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ghost.svg
 * tags
 * - Gaming / RPG 
 */
export const PinkyIcon = GhostIcon;
export default PinkyIcon